import React from 'react';
import { Container } from '../ui/Container';
import { YoutubeIcon } from 'lucide-react';
export const BasicPage: React.FC = () => {
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-502">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-503" />
      <Container className="relative py-24" data-id="element-504">
        <div className="flex flex-col items-center text-center" data-id="element-505">
          <div className="mb-8 w-48 md:w-64" data-id="element-506">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2DzbdAXB8rnWSnnsNSpx4E/widelogo.png" alt="DealFlow.ai Logo" className="w-full h-auto" data-id="element-507" />
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-508">
            Thank You For Your Application
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-16" data-id="element-509">
            Next, we will review your application, and if it's the right fit, we
            will be in touch.
          </p>
          <div className="w-full max-w-3xl mx-auto" data-id="element-510">
            <YoutubeIcon className="w-16 h-16 text-red-500 mx-auto mb-8" data-id="element-511" />
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-512">
              Discover the Deal Flow Show
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-513">
              We interview leading private equity, family office, and holding
              company founders, managing partners, and CEOs.
            </p>
            <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-2xl" data-id="element-514">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/wl3auA_P9co?si=Y2Ct2povmUUyPGN0" title="Deal Flow Show" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="absolute inset-0" data-id="element-515" />
            </div>
          </div>
        </div>
      </Container>
    </div>;
};